module.exports = antd.ConfigProvider;